export default {
    CREATED: 'ORDER_LOCAL_CREATED',
    MODIFIED: 'ORDER_UTC_MODIFIED',
};
